import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=b58c3e3a&scoped=true"
import script from "./list-table.vue?vue&type=script&lang=js"
export * from "./list-table.vue?vue&type=script&lang=js"
import style0 from "./list-table.vue?vue&type=style&index=0&id=b58c3e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58c3e3a",
  null
  
)

export default component.exports